import { ROUTE_GENERAR_ALERTA_FECHA_ZARPE } from './nombres/transacciones'

// import type { RouteConfig } from 'vue-router'

export default [
    {
        path: '/exportaciones/reportes/embarques',
        name: 'exportaciones-reportes-embarques',
        component: () => import('@/views/pages/exportaciones/reportes/embarques/Embarque.vue'),
        meta: {
            title: 'i18n:Embarques',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-reporte-embarque',
            // pageTitle: "Exportaciones",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                    to: '/',
                },
                {
                    text: 'Embarques',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/reportes/consultarEmbarque',
        name: 'exportaciones-informes-embarque-salem',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consulta_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-embarque-salem',
            // pageTitle: "Exportaciones",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                    to: '/',
                },
                {
                    text: 'exportaciones.informes.page.consulta_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/controlETA',
        name: 'exportaciones-informes-control-eta',
        component: () => import('@/views/pages/panacea/ControlETA.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.control_eta',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-control-eta',
            // pageTitle: "Control ETA",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.control_eta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/dashboardETA',
        name: 'exportaciones-dashboard-resumen-mercado',
        component: () => import('@/views/pages/panacea/DashboardETA.vue'),
        meta: {
            title: 'i18n:exportaciones.dashboard.page.dashboard',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-resumen-mercado',
            // pageTitle: "Dashboard",
            breadcrumb: [
                {
                    text: 'exportaciones.dashboard.page.dashboard',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/dashboard/monitorAnticipo',
        name: 'exportaciones-dashboard-monitor-anticipo',
        component: () => import('@/views/pages/exportaciones/dashboard/monitorAnticipo.vue'),
        meta: {
            title: 'i18n:exportaciones.dashboard.page.monitor_anticipo',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-anticipo',
            // pageTitle: "Monitor Anticipo",
            breadcrumb: [
                {
                    text: 'Dashboard',
                },
                {
                    text: 'exportaciones.dashboard.page.monitor_anticipo',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/dashboard/monitorContenedoresFacturar',
        name: 'exportaciones-dashboard-monitor-contenedores-facturar',
        component: () => import('@/views/pages/exportaciones/dashboard/monitorContenedoresFacturar.vue'),
        meta: {
            title: 'i18n:exportaciones.monitor_contenedor',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-contenedores-facturar',
            // pageTitle: "Contenedores X Facturar",
            layout: 'full',
            // breadcrumb: [
            //     {
            //         text: "Dashboard"
            //     },
            //     {
            //         text: "Monitor",
            //         active: true,
            //     },
            // ],
        },
    },
    {
        path: '/exportaciones/dashboard/monitorContenedores',
        name: 'exportaciones-dashboard-monitor-contenedores',
        component: () => import('@/views/pages/exportaciones/dashboard/MonitorContenedores.vue'),
        meta: {
            title: 'i18n:exportaciones.monitor_contenedor',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-contenedores',
            // breadcrumb: [
            //     {
            //         text: "Dashboard"
            //     },
            //     {
            //         text: "Monitor",
            //         active: true,
            //     },
            // ],
        },
    },
    {
        path: '/exportaciones/dashboard/monitorOrdenesPedido',
        name: 'exportaciones-dashboard-monitor-ordenes-pedido',
        component: () => import('@/views/pages/exportaciones/dashboard/MonitorOrdenesPedido.vue'),
        meta: {
            title: 'i18n:exportaciones.monitor_ordenes_pedido',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-ordenes-pedido',
        },
    },
    {
        path: '/exportaciones/dashboard/monitorOrdenesPedidoFc',
        name: 'exportaciones-dashboard-monitor-ordenes-pedido-fc',
        component: () => import('@/views/pages/exportaciones/dashboard/MonitorOrdenesPedidoFc.vue'),
        meta: {
            title: 'i18n:exportaciones.monitor_ordenes_pedido_fc',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-ordenes-pedido-fc',
        },
    },
    {
        path: '/exportaciones/dashboard/monitorProyecciones',
        name: 'exportaciones-dashboard-monitor-proyecciones',
        component: () => import('@/views/pages/exportaciones/dashboard/proyecciones/MonitorProyecciones.vue'),
        meta: {
            title: 'i18n:exportaciones.monitor_proyecciones',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-proyecciones',
        },
    },
    {
        path: '/exportaciones/transacciones',
        name: 'exportaciones-transacciones-documentos',
        component: () => import('@/views/pages/exportaciones/transacciones/proformas.vue'),
        meta: {
            title: 'i18n:Transacciones',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-documentos',
            pageTitle: 'Transacciones',
            breadcrumb: [
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/tarifaNaviera/:data?/:plan?',
        name: 'exportaciones-transacciones-tarifa-naviera',
        component: () => import('@/views/pages/exportaciones/transacciones/TarifasNavieras.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_tarifa',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-tarifa-naviera',
            //pageTitle: "exportaciones.transacciones.page.emision_tarifa",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_tarifa',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/booking/:data?/:plan?',
        name: 'exportaciones-transacciones-reserva-booking',
        component: () => import('@/views/pages/exportaciones/transacciones/reservaBooking.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_booking',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-reserva-booking',
            //pageTitle: "exportaciones.transacciones.page.emision_booking",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_booking',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/planificacion_booking',
        name: 'exportaciones-transacciones-planificacion-booking',
        component: () => import('@/views/pages/exportaciones/transacciones/PlanificacionBooking.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.planificacion_booking',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-planificacion-booking',
            //pageTitle: "exportaciones.transacciones.page.planificacion_booking",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.planificacion_booking',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/generar-alerta-fecha-zarpe',
        name: ROUTE_GENERAR_ALERTA_FECHA_ZARPE,
        component: () => import('@/views/pages/exportaciones/transacciones/GenerarAlertaFechaZarpe.vue'),
        meta: {
            title: 'exportaciones.transacciones.generarAlertaFechaZarpe.page',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-generar-alerta-fecha-zarpe',
            // pageTitle: 'i18n:exportaciones.transacciones.generarAlertaFechaZarpe.page',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
                {
                    text: 'exportaciones.transacciones.generarAlertaFechaZarpe.page',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/cobranzaMercado',
        name: 'exportaciones-informes-cobranza-mercado',
        component: () => import('@/views/pages/exportaciones/reportes/embarques/CobranzaMercado.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.cobranza_mercado',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-cobranza-mercado',
            // pageTitle: 'Cobranza por Mercado',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.cobranza_mercado',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultaTarifaNaviera',
        name: 'exportaciones-informes-tarifa-naviera',
        component: () => import('@/views/pages/exportaciones/reportes/TarifaNaviera.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consulta_tarifa',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-tarifa-naviera',
            //pageTitle: "exportaciones.informes.page.consulta_tarifa",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consulta_tarifa',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/parametrosChina',
        name: 'exportaciones-mantenimiento-parametros-china',
        component: () => import('@/views/pages/panacea/MantemientoPanacea.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.param_china',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-parametros-china',
            pageTitle: 'Parametros China',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.param_china',
                    active: true,
                },
            ],
        },
    },

    //Exportacion 2022 - ??
    {
        path: '/exportaciones/mantenimiento/mestroMercado',
        name: 'exportaciones-mantenimiento-maestro-mercado',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroMercado.vue'),
        meta: {
            title: 'i18n:Mercados',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-mercado',
            // pageTitle: "Mercados",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Mercados',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroPuerto',
        name: 'exportaciones-mantenimiento-maestro-puerto',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroPuerto.vue'),
        meta: {
            title: 'i18n:Puertos',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-puerto',
            // pageTitle: "Puertos",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Puertos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroAgenciaNaviera',
        name: 'exportaciones-mantenimiento-maestro-agencia-naviera',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroAgenciaNaviera.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.ag_naviera',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-agencia-naviera',
            // pageTitle: "Agencias Navieras",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.ag_naviera',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroLineaNaviera',
        name: 'exportaciones-mantenimiento-maestro-linea-naviera',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroLineaNaviera.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.ln_naviera',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-linea-naviera',
            //pageTitle: "Lineas Navieras",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.ln_naviera',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroTipoContrato',
        name: 'exportaciones-mantenimiento-maestro-tipo-contrato',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroTipoContrato.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.ln_naviera',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-tipo-contrato',
            // pageTitle: "Maestro",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.tipo_contrato',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroTipoContenedor',
        name: 'exportaciones-mantenimiento-maestro-tipo-contenedor',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroTipoContenedor.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.tipo_contenedor',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-tipo-contenedor',
            // pageTitle: "Tipos de Contenedores",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.tipo_contenedor',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroTerminalEmbarque',
        name: 'exportaciones-mantenimiento-maestro-terminal-embarque',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroTerminalEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.terminal_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-terminal-embarque',
            // pageTitle: "Terminales de Embarque",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.terminal_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroBuque',
        name: 'exportaciones-mantenimiento-maestro-buque',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroBuque.vue'),
        meta: {
            title: 'i18n:Buques',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-buque',
            // pageTitle: "Buques",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Buques',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroTransportadora',
        name: 'exportaciones-mantenimiento-maestro-transportadora',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroTransportadora.vue'),
        meta: {
            title: 'i18n:Transportadoras',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-transportadora',
            // pageTitle: "Transportadoras",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Transportadoras',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroConductor',
        name: 'exportaciones-mantenimiento-maestro-conductor',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroConductor.vue'),
        meta: {
            title: 'i18n:Conductores',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-conductor',
            // pageTitle: "Conductores",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Conductores',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroVehiculo',
        name: 'exportaciones-mantenimiento-maestro-vehiculo',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroVehiculo.vue'),
        meta: {
            title: 'i18n:Vehiculos',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-vehiculo',
            // pageTitle: "Vehiculos",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Vehiculos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroTipoVehiculo',
        name: 'exportaciones-mantenimiento-maestro-tipo-vehiculo',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroTipoVehiculo.vue'),
        meta: {
            title: 'i18n:Tipos de Vehiculos',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-tipo-vehiculo',
            // pageTitle: "Tipos de Vehiculos",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Tipos de Vehiculos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroCalculoPesoBruto',
        name: 'exportaciones-mantenimiento-maestro-peso-bruto',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroPesoBruto.vue'),
        meta: {
            title: 'i18n:Tipo peso bruto',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-peso-bruto',
            // pageTitle: "Tipo de peso bruto",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Tipo de peso bruto',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroAseguradora',
        name: 'exportaciones-mantenimiento-maestro-aseguradora',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroAseguradora.vue'),
        meta: {
            title: 'i18n:Aseguradoras',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-aseguradora',
            // pageTitle: "Aseguradoras",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Aseguradoras',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroConceptoTarifa',
        name: 'exportaciones-mantenimiento-concepto-tarifa',
        component: () => import('@/views/pages/exportaciones/mantenimiento/MaestroConceptoTarifa.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.concepto_tarifa',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-concepto-tarifa',
            // pageTitle: "Concepto Tarifa",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Concepto Tarifa',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/emisionProforma/:num_doc?',
        name: 'exportaciones-transaccion-emision-proforma',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionProforma.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_Proforma',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-proforma',
            // pageTitle: "Emision Proforma",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_Proforma',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/planificacionEmbarque',
        name: 'exportaciones-transacciones-planificacion-embarque',
        component: () =>
            import('@/views/pages/exportaciones/transacciones/planificacionEmbarque/PlanificacionEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.planificacion_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-planificacion-embarque',
            // pageTitle: "Emision Proforma",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.planificacion_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/despachoEmbarque',
        name: 'exportaciones-transacciones-despacho-embarque',
        component: () => import('@/views/pages/exportaciones/transacciones/despachoEmbarque/DespachoEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.despacho_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-despacho-embarque',
            // pageTitle: "Emision Proforma",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.despacho_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/configuracionFicha/:ficha?',
        name: 'exportaciones-mantenimiento-configuracion-ficha',
        component: () => import('@/views/pages/exportaciones/configuracion/fichaCliente.vue'),
        meta: {
            title: 'i18n:exportaciones.configuracion.page.config_ficha',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-configuracion-ficha',
            // pageTitle: 'Configuracion Ficha',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Configuracion',
                },
                {
                    text: 'exportaciones.configuracion.page.config_ficha',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/firmas-documentos/:firma?',
        name: 'exportaciones-configuracion-firmas-documentos',
        component: () => import('@/views/pages/exportaciones/configuracion/firmasDocumentos.vue'),
        meta: {
            title: 'i18n:exportaciones.configuracion.page.firma_doc',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-firmas-documentos',
            // pageTitle: 'Firmas de Documentos',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Configuracion',
                },
                {
                    text: 'exportaciones.configuracion.page.firma_doc',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/documento',
        name: 'exportaciones-configuracion-documento',
        component: () => import('@/views/pages/exportaciones/configuracion/documento/Documento.vue'),
        meta: {
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-documento',
            // pageTitle: "documento",
            breadcrumb: [
                {
                    text: 'exportaciones.menu_title',
                },
                {
                    text: 'global.menu.configuracion',
                },
                {
                    text: 'exportaciones.configuracion.documento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/documento/proceso/:id_documento?',
        name: 'exportaciones-configuracion-proceso-documento',
        props: true,
        component: () => import('@/views/pages/exportaciones/configuracion/documento/ProcesoDocumento.vue'),
        meta: {
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-proceso-documento',
            // pageTitle: "documento",
            breadcrumb: [
                {
                    text: 'exportaciones.menu_title',
                },
                {
                    text: 'global.menu.configuracion',
                },
                {
                    text: 'exportaciones.configuracion.documento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/generarDocumentos',
        name: 'exportaciones-configuracion-generar-documentos',
        component: () => import('@/views/pages/exportaciones/configuracion/generarDocumentos/GenerarDocumentos.vue'),
        meta: {
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-generar-documentos',
            // pageTitle: "documento",
            breadcrumb: [
                {
                    text: 'exportaciones.menu_title',
                },
                {
                    text: 'global.menu.configuracion',
                },
                {
                    text: 'exportaciones.configuracion.page.generar_documentos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/fichaCliente',
        name: 'exportaciones-mantenimiento-ficha-cliente',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroFichasCliente.vue'),
        meta: {
            title: 'i18n:exportaciones.configuracion.page.ficha_cliente',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-ficha-cliente',
            // pageTitle: 'Fichas de Cliente',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.configuracion.page.ficha_cliente',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/ActualizacionBooking',
        name: 'exportaciones-informes-actualizar-booking',
        component: () => import('@/views/pages/exportaciones/reportes/consultarBooking.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consulta_booking',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-actualizar-booking',
            //pageTitle: "exportaciones.informes.page.consulta_booking",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consulta_booking',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/correoCliente/:cliente?',
        name: 'exportaciones-mantenimiento-correo-cliente',
        component: () => import('@/views/pages/exportaciones/mantenimiento/Componentes/correoCliente.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.config_alerta_correo',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-correo-cliente',
            // pageTitle: "Alerta Correo",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.config_alerta_correo',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/alertasCorreo',
        name: 'exportaciones-mantenimiento-alertas-correo',
        component: () => import('@/views/pages/exportaciones/mantenimiento/configuracionAlertaCorreo.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.alerta_correo',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-alertas-correo',
            // pageTitle: "Alerta Correo",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.alerta_correo',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroSegmento',
        name: 'exportaciones-mantenimiento-segmento',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroSegmento.vue'),
        meta: {
            title: 'i18n:Segmentos',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-segmento',
            // pageTitle: "Segmentos",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Segmentos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroJefePlanta',
        name: 'exportaciones-mantenimiento-maestro-jefe-planta',
        component: () => import('@/views/pages/exportaciones/mantenimiento/MaestroJefePlanta.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.config_jefe_planta',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-jefe-planta',
            // pageTitle: "Jefe Planta",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.config_jefe_planta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarProformas',
        name: 'exportaciones-informes-consultar-proformas',
        component: () => import('@/views/pages/exportaciones/reportes/consultarProforma.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.proforma',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-proformas',
            // pageTitle: "Consultar Proformas",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.proforma',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/generarSecuencia',
        name: 'exportaciones-transacciones-generar-secuencia',
        component: () => import('@/views/pages/exportaciones/transacciones/generarSecuencia.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.generar_sec',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-generar-secuencia',
            // pageTitle: "Generar Secuencia",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.generar_sec',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/procesoEmbarque:id_res_emb_det?',
        name: 'exportaciones-transacciones-proceso-embarque',
        //component: () => import('@/views/pages/exportaciones/transacciones/procesoEmbarque.vue'),
        component: () => import('@/views/pages/exportaciones/transacciones/EmisionEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.proceso_pre_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-proceso-embarque',
            // pageTitle: "Proceso Pre-Embarque/Embarque",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.proceso_pre_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/generarGuiaRemision:id_res_emb_det?',
        name: 'exportaciones-transacciones-generar-guia-remision',
        component: () => import('@/views/pages/exportaciones/transacciones/GenerarGuiaRemision.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.gen_guia_remision',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-generar-guia-remision',
            // pageTitle: "Generar Guia de remisión",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.gen_guia_remision',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/procesoGuiaRemision',
        name: 'exportaciones-transacciones-proceso-guia-remision',
        component: () => import('@/views/pages/exportaciones/transacciones/ProcesoGuiaRemision.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.procesar_gr',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-proceso-guia-remision',
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.procesar_gr',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transaccion/preEmbarque',
        name: 'exportaciones-transacciones-pre-embarque',
        component: () => import('@/views/pages/exportaciones/transacciones/PreEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.pre_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-pre-embarque',
            // pageTitle: "Pre-Embarque/Embarque",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.pre_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/roleo',
        name: 'exportaciones-transacciones-proceso-roleo',
        component: () => import('@/views/pages/exportaciones/transacciones/roleoEmbarque.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.roleo',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-trasacciones-proceso-roleo',
            // pageTitle: "Roleo",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.roleo',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transaccion/emisionFacturaComercial',
        name: 'exportaciones-transaccion-emision-factura-comercial',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionFacturaComercial.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_fac_comercial',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-factura-comercial',
            // pageTitle: "Emision de Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_fac_comercial',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transaccion/procesoFacturaComercial/:num_doc?',
        name: 'exportaciones-transaccion-proceso-factura-comercial',
        component: () => import('@/views/pages/exportaciones/transacciones/procesoFacturaComercial.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_fac_comercial',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-factura-comercial',
            // pageTitle: "Emisión Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_fac_comercial',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarFacturaComercial',
        name: 'exportaciones-informes-consultar-factura-comercial',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarFacturaComercial.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_fac_comercial',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-factura-comercial',
            // pageTitle: "Consultar Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_fac_comercial',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transaccion/calculoPesoBruto',
        name: 'exportaciones-transaccion-calculo-peso-bruto',
        component: () => import('@/views/pages/exportaciones/transacciones/CalculoPesoBruto.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.peso_bruto',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-calculo-peso-bruto',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.peso_bruto',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transaccion/procesocalculoPesoBruto/:num_doc?',
        name: 'exportaciones-transaccion-proceso-calculo-peso-bruto',
        component: () => import('@/views/pages/exportaciones/transacciones/procesoCalculoPesoBruto.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.proceso_peso_bruto',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-calculo-peso-bruto',
            // pageTitle: "Proceso Cálculo Peso Bruto",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.proceso_peso_bruto',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarFacturaPesoBruto',
        name: 'exportaciones-informes-consultar-factura-peso-bruto',
        component: () => import('@/views/pages/exportaciones/reportes/consultarFacturaPesoBruto.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_peso_bruto',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-factura-peso-bruto',
            // pageTitle: "Consultar Peso Bruto",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_peso_bruto',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarFactorPlastico',
        name: 'exportaciones-informes-consultar-factor-plastico',
        component: () => import('@/views/pages/exportaciones/reportes/consultarFactorPlastico.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.embarque_plastico',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-factor-plastico',
            // pageTitle: "Consultar Embarque Plástico",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.embarque_plastico',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/especificacionPlanta/:num_doc?',
        name: 'exportaciones-transaccion-especificacion-planta',
        component: () => import('@/views/pages/exportaciones/transacciones/especificacionPlanta.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.especificacion',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-especificacion-planta',
            // pageTitle: "Especificacion Planta",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.especificacion',
                    active: true,
                },
            ],
        },
    },
    // Cobros
    {
        path: '/exportaciones/transaccion/emisionCobro/:num_doc?',
        name: 'exportaciones-transaccion-emision-cobro',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionCobro.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_cobro',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-cobro',
            // pageTitle: "Emision de Cobros",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_cobro',
                    active: true,
                },
            ],
        },
    },
    // Cobros
    // Factura Fiscal
    {
        path: '/exportaciones/transaccion/emisionFacturaFiscal',
        name: 'exportaciones-transaccion-emision-factura-fiscal',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionFacturaFiscal.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_fac_fiscal',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-factura-fiscal',
            // pageTitle: "Emision Factura Fiscal",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_fac_fiscal',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarFacturaFiscal',
        name: 'exportaciones-informes-consultar-factura-fiscal',
        component: () => import('@/views/pages/exportaciones/reportes/consultarFacturaFiscal.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_fac_fiscal',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-factura-fiscal',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_fac_fiscal',
                    active: true,
                },
            ],
        },
    },
    // Factura Fiscal
    {
        path: '/exportaciones/configuracion/plantaUsuario',
        name: 'exportaciones-configuracion-planta-usuario',
        component: () => import('@/views/pages/exportaciones/configuracion/configuracionPlantasUsuario.vue'),
        meta: {
            title: 'i18n:exportaciones.configuracion.page.plantas_asignadas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-planta-usuario',
            // pageTitle: "Plantas Asignadas",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Configuracion',
                },
                {
                    text: 'exportaciones.configuracion.page.plantas_asignadas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/procesoFacturaFiscal/:num_doc?',
        name: 'exportaciones-transaccion-proceso-factura-fiscal',
        component: () => import('@/views/pages/exportaciones/transacciones/ProcesoFacturaFiscal.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_fac_fiscal',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-factura-fiscal',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_fac_fiscal',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroPlantaRelacionada',
        name: 'exportaciones-mantenimiento-maestro-planta-relacionada',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroPlantaRelacionada.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.planta_relacionadas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-planta-relacionada',
            // pageTitle: "Plantas Relacionadas",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.planta_relacionadas',
                    active: true,
                },
            ],
        },
    },
    // Factura Fiscal
    {
        path: '/exportaciones/informes/consultarCobros',
        name: 'exportaciones-informes-consultar-cobros',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarCobro.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_cobros',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-cobros',
            // pageTitle: "Consultar Cobros",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_cobros',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroDistritoAduanero',
        name: 'exportaciones-mantenimiento-distrito-aduanero',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroDistritoAduanero.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.distrito_aduanero',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-distrito-aduanero',
            // pageTitle: "Distri Aduanero",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.distrito_aduanero',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroBanco',
        name: 'exportaciones-mantenimiento-maestro-banco',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroBanco.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.bancos',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-bancos',
            // pageTitle: "Bancos",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.bancos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transaccion/guiaRemisionEmbarque',
        name: 'exportaciones-transacciones-guia-remision-datos-embarque',
        component: () => import('@/views/pages/exportaciones/transacciones/GuiaRemisionDatEmb.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.gr_embarque',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-guia-remision-datos-embarque',
            // pageTitle: "Guia Remisión Datos Embarque",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.gr_embarque',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/puertoCiudad',
        name: 'exportaciones-mantenimiento-maestro-puerto-ciudad',
        component: () => import('@/views/pages/exportaciones/mantenimiento/maestroPuertoCiudad.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.ciudades_puerto',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-puerto-ciudad',
            // pageTitle: "exportaciones.mantenimiento.page.ciudades_puerto",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.ciudades_puerto',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/notaCredito',
        name: 'exportaciones-transacciones-emision-nota-credito',
        component: () => import('@/views/pages/exportaciones/transacciones/EmisionNotaCredito.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.nota_credito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-emision-nota-credito',
            // pageTitle: "Nota de Credito",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.nota_credito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/edicionNotasCredito/:num_doc?',
        name: 'exportaciones-transacciones-edicion-nota-credito',
        component: () => import('@/views/pages/exportaciones/transacciones/EditarNotaCredito.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.nota_credito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-edicion-nota-credito',
            // pageTitle: "Nota de Credito",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.nota_credito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/notaDebito',
        name: 'exportaciones-transacciones-emision-nota-debito',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionNotaDebito.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.nota_debito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-emision-nota-debito',
            // pageTitle: "Nota de Debito",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.nota_debito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/edicionNotasDebito/:num_doc?',
        name: 'exportaciones-transacciones-edicion-nota-debito',
        component: () => import('@/views/pages/exportaciones/transacciones/editarNotaDebito.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.nota_debito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-edicion-nota-debito',
            // pageTitle: "Nota de Debito",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.nota_debito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarNotasCredito',
        name: 'exportaciones-informes-consultar-notas-credito',
        component: () => import('@/views/pages/exportaciones/reportes/consultarNotaCredito.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_nota_credito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-notas-credito',
            // pageTitle: "Nota de Credito",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_nota_credito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarNotasDebito',
        name: 'exportaciones-informes-consultar-notas-debito',
        component: () => import('@/views/pages/exportaciones/reportes/consultarNotaDebito.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_nota_dedito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-notas-debito',
            // pageTitle: "Nota de Debito",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_nota_dedito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/cierreDiario',
        name: 'exportaciones-transacciones-cierre-diario',
        component: () => import('@/views/pages/exportaciones/transacciones/cierreDiario.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.cierre_diario',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-cierre-diario',
            pageTitle: 'Cierre Diario',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.cierre_diario',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/emisionCierreDiario/:num_doc?',
        name: 'exportaciones-transacciones-emision-cierre-diario',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionCierreDiario.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.cierre_diario',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-emision-cierre-diario',
            // pageTitle: "Cierre Diario",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.cierre_diario',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/certificadosExportacion',
        name: 'exportaciones-informes-consultar-certificados-exportacion',
        component: () => import('@/views/pages/exportaciones/reportes/CertificadosExportacion.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.certificado_exportacion',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-certificados-exportacion',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.transacciones.certificado_exportacion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/dashboard/monitorVentas',
        name: 'exportaciones-dashboard-monitor-ventas',
        component: () => import('@/views/pages/exportaciones/dashboard/monitorVentas.vue'),
        // component: () => import('@/views/pages/exportaciones/dashboard/exportaciones/FacturaComercialDashboard.vue'),
        meta: {
            title: 'i18n:exportaciones.dashboard.page.monitor_ventas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-ventas',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Dashboard',
                },
                {
                    text: 'exportaciones.dashboard.page.monitor_ventas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/dashboard/year-to-year',
        name: 'exportaciones-dashboard-year-to-year',
        // TODO: Renombrar YearToYear
        component: () => import('@/views/pages/exportaciones/dashboard/exportaciones/YearToYear.vue'),
        meta: {
            title: 'i18n:exportaciones.dashboard.page.yearToYear',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-year-to-year',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Dashboard',
                },
                {
                    text: 'exportaciones.dashboard.page.yearToYear',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/dashboard/precio-por-semana',
        name: 'exportaciones-dashboard-precio-por-semana',
        component: () => import('@/views/pages/exportaciones/dashboard/precioPorSemana/PrecioPorSemana.vue'),
        meta: {
            title: 'i18n:exportaciones.dashboard.page.precioPorSemana',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-precio-por-semana',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Dashboard',
                },
                {
                    text: 'exportaciones.dashboard.page.precioPorSemana',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/DetallesCobros',
        name: 'exportaciones-informes-consultar-detalles-cobros',
        component: () => import('@/views/pages/exportaciones/reportes/DetallesCobros.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.detalles_cobros',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-detalles-cobros',
            // pageTitle: "Detalles de Cobros",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                // {
                //     text: "Cobros",
                //     active: true,
                // },
                {
                    text: 'exportaciones.informes.page.detalles_cobros',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/saldosClientes',
        name: 'exportaciones-informes-saldos-clientes',
        component: () => import('@/views/pages/exportaciones/reportes/saldosClientes.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.saldo_clientes',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-saldos-clientes',
            // pageTitle: "Saldos por Clientes",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                // {
                //     text: "Saldos",
                //     active: true,
                // },
                {
                    text: 'exportaciones.informes.page.saldo_clientes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/ActualizacionDetallesBooking',
        name: 'exportaciones-informes-anular-detalles-booking',
        component: () => import('@/views/pages/exportaciones/reportes/AnularDetallesBooking.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.actualizar_detalle_booking',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-anular-detalles-booking',
            //pageTitle: "exportaciones.informes.page.actualizar_detalle_booking",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.actualizar_detalle_booking',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarSaldosProformas',
        name: 'exportaciones-informes-consultar-saldos-proformas',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarSaldosProformas.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.saldo_proforma',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-saldos-proformas',
            //pageTitle: "exportaciones.informes.page.saldo_proforma",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                    // active: true,
                },
                {
                    text: 'exportaciones.informes.page.saldo_proforma',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/EmbarqueNoExportado',
        name: 'exportaciones-transaccion-embarque-no-exportado',
        component: () => import('@/views/pages/exportaciones/transacciones/embarqueNoExportado.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emb_no_exportado',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-embarque-no-exportado',
            //pageTitle: "Embarque No Exportado",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.emb_no_exportado',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/EmisionEmbarqueNoExportado/:num_doc?',
        name: 'exportaciones-transaccion-emision-embarque-no-exportado',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionEmbarqueNoExportado.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_emb_no_exportado',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-emision-embarque-no-exportado',
            // pageTitle: "Emision Embarque No Exportado",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_emb_no_exportado',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/seguimientoETA',
        name: 'exportaciones-informes-seguimiento-eta',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarSeguimientoEta.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.seguimiento_eta',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-seguimiento-eta',
            // pageTitle: "Seguimiento ETA",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.seguimiento_eta',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarLibrasFacturadas',
        name: 'exportaciones-informes-consultar-lbs-facturadas',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarLbsFacturadas.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.lbs_facturadas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-lbs-facturadas',
            //pageTitle: "exportaciones.informes.page.lbs_facturadas",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.lbs_facturadas',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarCierrePresidencia',
        name: 'exportaciones-informes-consultar-cierre-presidencia',
        component: () => import('@/views/pages/exportaciones/reportes/consultarCierrePresidencia.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.cierre_presidencia',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-cierre-presidencia',
            // pageTitle: "Consultar Cierre Presidencia",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.cierre_presidencia',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transacciones/cierrePresidencia',
        name: 'exportaciones-transacciones-cierre-presidencia',
        component: () => import('@/views/pages/exportaciones/transacciones/cierrePresidencia.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.cierre_presidencia',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-cierre-presidencia',
            // pageTitle: "Cierre Presidencia",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.cierre_presidencia',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/emisionCierrePresidencia/:num_doc?',
        name: 'exportaciones-transacciones-emision-cierre-presidencia',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionCierrePresidencia.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_cierre_presidencia',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-emision-cierre-presidencia',
            // pageTitle: "Cierre Presidencia",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_cierre_presidencia',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/facturas-comerciales/:id_factura?/documentacion/:id_documentacion_factura?',
        name: 'exportaciones-transacciones-factura-documentacion',
        component: () =>
            import('@/views/pages/exportaciones/transacciones/facturaDocumentacion/FacturaDocumentacion.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.factura_documentacion',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-factura-documentacion',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.factura_documentacion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/maestroDireccionEntrega',
        name: 'exportaciones-mantenimiento-maestro-direccion-entrega',
        component: () => import('@/views/pages/exportaciones/mantenimiento/MaestroDireccionEntrega.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.direccion_entrega',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-direccion-entrega',
            //pageTitle: "exportaciones.mantenimiento.direccion_entrega",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Mantenimiento',
                    to: '/',
                },
                {
                    text: 'exportaciones.mantenimiento.direccion_entrega',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/couriers/:id_courier?',
        name: 'exportaciones-mantenimiento-maestro-courier',
        props: true,
        component: () => import('@/views/pages/exportaciones/mantenimiento/courier/couriers.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.courier',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-maestro-courier',
            //pageTitle: "exportaciones.mantenimiento.direccion_entrega",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Mantenimiento',
                    to: '/',
                },
                {
                    text: 'exportaciones.mantenimiento.courier',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/consultarLbsDetalladas',
        name: 'exportaciones-informes-consultar-lbs-detalladas',
        component: () => import('@/views/pages/exportaciones/reportes/consultarLbsDetalladas.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.lbs_detalladas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-lbs-detalladas',
            // pageTitle: "Consultar Libras Detalladas",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.lbs_detalladas',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/facturas-comerciales/consultarDocumentacion',
        name: 'exportaciones-informes-consultar-factura-documentacion',
        component: () =>
            import('@/views/pages/exportaciones/reportes/facturaDocumentacion/consultarDocumentacionFactura.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_factura_documentacion',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-factura-documentacion',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_factura_documentacion',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/dashboard/monitorEmbarque',
        name: 'exportaciones-dashboard-monitor-embarque',
        component: () => import('@/views/pages/exportaciones/dashboard/monitorEmbarque.vue'),
        meta: {
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-embarque',
            // layout: "full"
        },
    },
    {
        path: '/exportaciones/dashboard/monitor-documentacion',
        name: 'exportaciones-dashboard-monitor-documentacion',
        component: () => import('@/views/pages/exportaciones/dashboard/MonitorDocumentacion.vue'),
        meta: {
            resource: 'Exportaciones',
            action: 'ver-exportaciones-dashboard-monitor-documentacion',
            // layout: "full"
        },
    },

    {
        path: '/exportaciones/informes/totalExportacionAnual',
        name: 'exportaciones-informes-total-exportacion-anual',
        component: () => import('@/views/pages/exportaciones/reportes/TotalExportacionAnual.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.total_exportacion_anual',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-total-exportacion-anual',
            // pageTitle: "Consultar Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.total_exportacion_anual',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarLbsNetas',
        name: 'exportaciones-informes-consultar-lbs-netas',
        component: () => import('@/views/pages/exportaciones/reportes/consultarLbsNetas.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_lbs_netas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-lbs-netas',
            // pageTitle: "Consultar Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_lbs_netas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarPolizaMercancia',
        name: 'exportaciones-informes-consultar-polizas',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarPolizaMercancia.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_polizas',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-polizas',
            // pageTitle: "Consultar Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_polizas',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/alertasCorreos',
        name: 'exportaciones-configuracion-alertas-correos',
        component: () => import('@/views/pages/exportaciones/mantenimiento/MaestroAlertaCorreo.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.alertas_correos',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-alertas-correos',
            pageTitle: 'exportaciones.mantenimiento.page.alertas_correos',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Configuración',
                },
                {
                    text: 'exportaciones.mantenimiento.page.alertas_correos',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/pre-aprobacion-factura-fiscal',
        name: 'exportaciones-transacciones-pre-aprobacion-factura-fiscal',
        component: () => import('@/views/pages/exportaciones/transacciones/preaprobacionFacturaFiscal.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.pre_aprobacion_factura_fiscal',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-pre-aprobacion-factura-fiscal',
            //pageTitle: "exportaciones.transacciones.page.planificacion_booking",
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.pre_aprobacion_factura_fiscal',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarPolizaCredito',
        name: 'exportaciones-informes-poliza-credito',
        component: () => import('@/views/pages/exportaciones/reportes/poliza/consultarPolizaCredito.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_poliza_credito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-poliza-credito',
            // pageTitle: "Consultar Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_poliza_credito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/crearPolizaCredito',
        name: 'exportaciones-transacciones-poliza-credito',
        component: () => import('@/views/pages/exportaciones/transacciones/crearPolizaCredito.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.poliza_credito',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-poliza-credito',
            // pageTitle: "Cierre Presidencia",
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.poliza_credito',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/emisionCruceAnticipoFactura/:num_doc?',
        name: 'exportaciones-transacciones-cruce-anticipo-factura',
        component: () => import('@/views/pages/exportaciones/transacciones/emisionCruceAnticipoFactura.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.cruce_anticipo_factura',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-cruce-anticipo-factura',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.transacciones.page.cruce_anticipo_factura',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarCruceAnticipoFactura',
        name: 'exportaciones-informes-consultar-cruce-anticipo-factura',
        component: () => import('@/views/pages/exportaciones/reportes/consultarCruceAnticipoFactura.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_cruce_anticipo_factura',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-cruce-anticipo-factura',
            breadcrumb: [
                {
                    text: 'Exportaciones',
                },
                {
                    text: 'Transaccion',
                },
                {
                    text: 'exportaciones.informes.page.consultar_cruce_anticipo_factura',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/modificacionTarifaDestino',
        name: 'exportaciones-transacciones-modificacion-tarifa-destino',
        component: () => import('@/views/pages/exportaciones/transacciones/ModificacionTarifaDestino.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.modificacion_tarifa',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-modificacion-tarifa-destino',
            pageTitle: 'exportaciones.transacciones.page.modificacion_tarifa',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.modificacion_tarifa',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/mantenimiento/responsableplanta',
        name: 'exportaciones-mantenimiento-responsable-planta',
        component: () => import('@/views/pages/exportaciones/mantenimiento/ResponsablePlanta.vue'),
        meta: {
            title: 'i18n:exportaciones.mantenimiento.page.responsable_planta',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-mantenimiento-responsable-planta',
            pageTitle: 'exportaciones.mantenimiento.page.responsable_planta',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'exportaciones.mantenimiento.page.responsable_planta',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/documentosLogistica',
        name: 'exportaciones-informes-consultar-documentos-logistica',
        component: () => import('@/views/pages/exportaciones/reportes/DocumentosLogistica.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.documento_logistica',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-documentos-logistica',
            // pageTitle: "Consultar Factura Comercial",
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.documento_logistica',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/sincronizacionCobro',
        name: 'exportaciones-transacciones-sincronizacion-cobro',
        component: () => import('@/views/pages/exportaciones/transacciones/SincronizacionCobro.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.sincronizacion_cobro',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-sincronizacion-cobro',
            breadcrumb: [
                {
                    text: 'Exportacion',
                    to: '/',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.sincronizacion_cobro',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/ingreso_bancario/:id_transferencia?',
        name: 'exportaciones-transacciones-ingreso-bancario',
        component: () => import('@/views/pages/exportaciones/transacciones/IngresoBancario.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.ingreso_bancario',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-ingreso-bancario',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.ingreso_bancario',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultar_ingreso_bancario',
        name: 'exportaciones-informes-consultar-ingreso-bancario',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarIngresoBancario.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_ingreso_bancario',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-ingreso-bancario',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_ingreso_bancario',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/maestroConsignatario',
        name: 'exportaciones-configuracion-maestro-consignatario',
        component: () => import('@/views/pages/exportaciones/configuracion/MaestroConsignatario.vue'),
        meta: {
            title: 'i18n:exportaciones.configuracion.page.maestro_consignatario',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-maestro-consignatario',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Configuracion',
                },
                {
                    text: 'exportaciones.configuracion.page.maestro_consignatario',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/precio-retorno-finca',
        name: 'exportaciones-informes-precio-retorno-finca',
        component: () => import('@/views/pages/exportaciones/reportes/PrecioRetornoFinca.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.precio_retorno_finca',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-precio-retorno-finca',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.precio_retorno_finca',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/consultarConvalidacionKardex',
        name: 'exportaciones-informes-consultar-convalidacion-kardex',
        component: () => import('@/views/pages/exportaciones/reportes/ConsultarConvalidacionKardex.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_convalidacion_kardex',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-convalidacion-kardex',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_convalidacion_kardex',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/emisionConvalidacionKardex',
        name: 'exportaciones-transacciones-emision-convalidacion-kardex',
        component: () => import('@/views/pages/exportaciones/transacciones/EmisionConvalidacionKardex.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.emision_convalidacion_kardex',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-emision-convalidacion-kardex',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.emision_convalidacion_kardex',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/ProcesoConvalidacionKardex/:idFactura?',
        name: 'exportaciones-transacciones-proceso-convalidacion-kardex',
        component: () => import('@/views/pages/exportaciones/transacciones/ConvalidacionKardex.vue'),
        props: route => ({ idFactura: Number(route.params.idFactura) || Number(route.query.idFactura) }),
        meta: {
            title: 'i18n:exportaciones.transacciones.convalidacion_kardex',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transaccion-proceso-convalidacion-kardex',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.convalidacion_kardex',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/informes/margenPorItem',
        name: 'exportaciones-informes-consultar-margen-item',
        component: () => import('@/views/pages/exportaciones/reportes/margenPorItem/ConsultaMargenPorItem.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.page.consultar_margen_item',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-consultar-margen-item',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Informes',
                },
                {
                    text: 'exportaciones.informes.page.consultar_margen_item',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/ingresoCostoProceso',
        name: 'exportaciones-transacciones-ingreso-costo-proceso',
        component: () => import('@/views/pages/exportaciones/transacciones/IngresoCostoProceso.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.ingreso_costo_proceso',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-ingreso-costo-proceso',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.ingreso_costo_proceso',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/ingresoCostoProduccion',
        name: 'exportaciones-transacciones-ingreso-costo-produccion',
        component: () => import('@/views/pages/exportaciones/transacciones/costoProduccion/IngresoCostoProduccion.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.ingreso_costo_produccion',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-ingreso-costo-produccion',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.ingreso_costo_produccion',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/transacciones/relacionItem',
        name: 'exportaciones-transacciones-relacion-item',
        component: () => import('@/views/pages/exportaciones/transacciones/relacionItem/RelacionItem.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.page.relacion_item',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-relacion-item',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.page.relacion_item',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/exportaciones/configuracion/parametrosExportaciones',
        name: 'exportaciones-configuracion-parametros-exportaciones',
        component: () => import('@/views/pages/exportaciones/configuracion/ParametrosExportaciones.vue'),
        meta: {
            title: 'i18n:exportaciones.configuracion.page.parametros_expo',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-configuracion-parametros-exportaciones',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Configuracion',
                },
                {
                    text: 'exportaciones.configuracion.page.parametros_expo',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/transacciones/diarioCruce/:num_doc?',
        name: 'exportaciones-transacciones-diario-cruce',
        component: () => import('@/views/pages/exportaciones/transacciones/diarioCruce/EmisionDiarioCruce.vue'),
        meta: {
            title: 'i18n:exportaciones.transacciones.diario_cruce.title',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-transacciones-diario-cruce',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'Transacciones',
                },
                {
                    text: 'exportaciones.transacciones.diario_cruce.title',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/exportaciones/informes/diarioCruce',
        name: 'exportaciones-informes-diario-cruce',
        component: () => import('@/views/pages/exportaciones/transacciones/diarioCruce/ConsultarDiarioCruce.vue'),
        meta: {
            title: 'i18n:exportaciones.informes.diario_cruce.title',
            resource: 'Exportaciones',
            action: 'ver-exportaciones-informes-diario-cruce',
            breadcrumb: [
                {
                    text: 'Exportacion',
                },
                {
                    text: 'informes',
                },
                {
                    text: 'exportaciones.informes.diario_cruce.title',
                    active: true,
                },
            ],
        },
    },
]

// as RouteConfig[]
